module.exports = __webpack_public_path__ + "c3c660e005f43fbfcadf6f59f2de5828.svg";